import { BackgroundCheckRequestStatus } from "@wingspanhq/background-checks/dist/lib/interfaces";
import {
  StepItem,
  StepsProps
} from "../../../../../../shared/components/Steps";

export const getBackgroundCheckProgressSteps = (
  status: BackgroundCheckRequestStatus
): StepItem[] => {
  const allStepsCombinations: Record<
    BackgroundCheckRequestStatus,
    StepsProps["steps"]
  > = {
    [BackgroundCheckRequestStatus.Success]: [
      {
        title: "Start",
        status: "Complete"
      },
      {
        title: "Processed",
        status: "Complete"
      },
      {
        title: "Complete",
        status: "Complete"
      }
    ],
    [BackgroundCheckRequestStatus.Processing]: [
      {
        title: "Start",
        status: "Complete"
      },
      {
        title: "Processed",
        status: "Active"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ],
    [BackgroundCheckRequestStatus.New]: [
      {
        title: "Start",
        status: "Pending"
      },
      {
        title: "Processed",
        status: "Pending"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ],
    [BackgroundCheckRequestStatus.Pending]: [
      {
        title: "Start",
        status: "Active"
      },
      {
        title: "Processed",
        status: "Pending"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ],
    [BackgroundCheckRequestStatus.Failed]: [
      {
        title: "Start",
        status: "Failed"
      },
      {
        title: "Processed",
        status: "Failed"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ]
  };

  return allStepsCombinations[status];
};
